module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch03"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter Three")])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Next morning Dido accompanied Flora upon a visit of condolence to Henry Lansdale. She was very eager to meet him; reasoning that a man who could earn such affection from his friends and such malice from his neighbours, could not fail to be interesting.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was another exceedingly hot day with not a cloud to be seen in the sky. Down beyond the river the hay was being cut and the scent of it carried right into the town. The two women walked slowly along the tree-shaded street.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I do not doubt,’ said Dido after walking for some time in silence, ‘from everything I have observed, that Mrs Midgely is a very malicious woman. But what I cannot yet quite determine is why her malice should be particularly directed against Mr Lansdale. Do you know of any reason why she should be his enemy?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘No, I do not!’ Flora Beaumont frowned prettily in the deep shade of her bonnet, her soft white nose wrinkling in a way which always put Dido in mind of a rabbit. ‘He is such a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("very")]), _vm._v(" delightful man. Why, I cannot conceive that he could have an enemy in the whole world! And besides, Mrs Midgely does not "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("know")]), _vm._v(" him.’ Her lips puckered in a childish pout. ‘The Lansdales have been here but a month and Mrs Midgely is not even upon visiting terms with them, you know.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Then perhaps she had "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("heard")]), _vm._v(" something ill of him.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘But I have told you, there is nothing ill to hear! Nothing at all!’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘There were, I understand, quarrels between aunt and nephew.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Oh, but they were nothing! It was just her way.’ Flora paused in the shade of a tree, twisting one finger daintily in the long ribbon of her bonnet. ‘I rather fancy she liked to quarrel sometimes, you know. There was always a great making up afterwards.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Perhaps,’ Dido suggested, trying her best not to injure her cousin’s sensitive feelings, ‘perhaps it is jealousy which turns Mrs M against him. He is after all so very fortunate – a poor young man taken in by his aunt, and now inheriting a great estate in Westmorland…’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Dido! Do not talk so! I cannot "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("bear")]), _vm._v(" it. You sound so "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("horribly")]), _vm._v(" suspicious.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘No, no,’ Dido assured her hastily. ‘I am not at all suspicious. I am only trying to understand why other people might be suspicious.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Well!’ cried Flora, clapping her hands together. ‘I can tell you why such a woman as Mrs Midgely is suspicious. It is because she is spiteful and cruel…and horrid. And we "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("must")]), _vm._v(" find a way to silence her. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("You")]), _vm._v(" must find a way, Dido. You are the clever one. The whole world is forever saying how very clever you are.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I am sure I am very much obliged to the world for its good opinion. And I certainly intend to silence Mrs Midgely if I can. But…’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She stopped suddenly because they had come now through the gates of Knaresborough House and, as they started up the sweep, she had caught sight of something rather strange.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A young boy in a gardener’s smock was digging a hole beneath the great boughs of the cedar tree which stood close by the gate. As Dido and Flora watched, he thrust his spade into the pile of excavated earth, picked up a bundle wrapped in sacking and dropped it into the hole.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Oh dear!’ cried Dido, almost without thinking, ‘is that a grave you are making?’ Impelled by overwhelming curiosity, she hurried towards him, leaving Flora frowning upon the gravel.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The boy looked up, pushing damp hair out of his eyes. He was about twelve years old with fair, almost white hair and a drift of freckles across his cheeks and nose. ‘It is Sam, is it not?’ said Dido. ‘We met when you came to dig the new flower-bed in Mrs Beaumont’s garden. Do you remember?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Oh yes, miss,’ he said with a smile. ‘I remember. You was very kind about that wasp sting.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘And today you are working for Mr Lansdale?’ Dido looked inquiringly towards the hole.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Yes miss,’ he said. ‘I’m burying Mrs Lansdale’s little dog.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Oh? Indeed!’ said Dido with great interest.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Been dead nearly a week, miss. I’d not come any closer if I were you.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She took a step back, for there was indeed a very unpleasant odour mixing with the scent of lilac and the dark smell of the cedar. ‘Nearly a week?’ She glanced anxiously back at Flora and calculated rapidly. ‘Then the dog died about the same time as Mrs Lansdale?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sam nodded. ‘They say he went missing the very night the old lady died. But they only found him this morning – dead and hidden in among the laurel bushes.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I see. How strange.’ How "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("very")]), _vm._v(" strange. She gazed thoughtfully at the gaping hole in the ground. Why should the dog die at the same time as his mistress? It seemed a remarkable coincidence – indeed it seemed a great deal more than a coincidence…‘But,’ she said carefully, ‘they do say, do they not, that a dog will sometimes pine away when the person to whom he has been devoted dies?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I don’t know about that, miss,’ said Sam. He too looked down at the open grave and rubbed the side of his nose, smearing dirt into the freckles. ‘It may be a dog’d pine away,’ he said slowly. ‘But I can’t see how any dog would be so heart-broke it’d crawl away into a bush and cut its own throat.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Oh no, no indeed,’ said Dido as she turned away, ‘you are quite right. Quite right.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I do not see,’ said Flora irritably, ‘why you should be so concerned about the death of a dog.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘But my dear cousin, it is of the greatest importance. For it would seem the dog died at the hand of man, and that must mean…’ She stopped herself. There was something so remarkably innocent about Flora’s childlike face – the wide blue eyes gazing at her in such a puzzled, unsuspecting way…")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Dido shrugged up her shoulders and merely said, ‘Well it is very strange, is it not?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But her thoughts were working rapidly. The dog had been killed. Why? Why should the animal meet its death at the very same time as its mistress…? Unless there had been dark forces at work here at Knaresborough House.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The great question must be: had the death of the lady been as unnatural as her pet’s? Dido found herself remembering the apothecary’s account of the large amount of opium mixture Mrs Lansdale had drunk. She could not help it; she was beginning to wonder whether there could be some truth in the rumours. Perhaps there was some agency at work here worse than the malice of gossip.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She approached the respectable red-brick front of Knaresborough House with increased interest – and more than a little suspicion.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("A remarkably young and inexperienced maid opened the door to them. She was very unsure of herself. She was unsure of how many curtsies she should make; unsure of whether Flora was to be addressed as ‘Miss’ or ‘Madam’ unsure whether her master was at home. And then, having ascertained that he "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("was")]), _vm._v(" at home, and that he would be ‘down directly’, she was very unsure indeed about which room the visitors should be shown into.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She stood for several moments in the spacious, white-painted entrance hall, looking anxiously from one closed door to another, her hands twisting clumsily in her apron. No superior servant appeared to advise her and Dido observed the scene with great interest, wondering how it came about that such a fine house should be so ill-served. She had expected a manservant to open the door – a fellow with a bit of dignity about him: and a footman perhaps in attendance too.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘It had better be the drawing room, I think,’ said the girl at last, throwing open a door, ‘though it’s not been used or put to rights since the day before the mistress died and I hope you’ll excuse it not being aired.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("They walked into the room and Dido looked about her with great interest.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was very gloomy from the blinds still being half-drawn, and the furnishings were as impersonal as those of any house that is offered to be let by the month – though very rich and substantial, as befitted one advertised as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("a spacious residence suitable to a gentleman of fortune.")]), _vm._v(" There was a wealth of solid mahogany furniture and silver candlesticks, a magnificent, steadily ticking wall clock, and sumptuous, over-long curtains of cream brocade which lay in folds upon the Axminster carpet; but there was little that spoke the character of the present occupants – except, perhaps, some pretty red shades which had been fitted over the candles by the hearth.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I believe,’ said Dido, turning to her cousin, ‘that, in general, it is possible to learn a great deal about our acquaintances from looking at their drawing rooms.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Is it?’ Flora looked startled. It was not an idea that had ever come into her head before.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Though,’ Dido admitted as she began to walk about the room, ‘on the present occasion, I do not know that I can deduce much beyond the fact that Mrs Lansdale was a rather vain woman.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Why do you say so?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘What other purpose is there in a red light but to flatter a woman’s face? And,’ she said, turning to the open pianoforte, ‘I see that she was a musical lady. And on the evening that she died she had been playing – or listening to…’ She took the sheet of music from the stand, ‘…"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Robin Adair")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Oh no! You are quite wrong, you know,’ said Flora, following her across the room. ‘I have never in my whole life known such a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("very")]), _vm._v(" unmusical woman. She "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("never")]), _vm._v(" played herself, and she quite hated to hear anyone else play.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Did she? That is strange. But perhaps that is why there is no other music here. And yet,’ Dido added thoughtfully, ‘it seems "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("someone")]), _vm._v(" has been playing: for here is the instrument open and the music set ready upon the stand…’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She picked up the sheet of music and studied it more closely. It was the usual kind of thing – to be found on music stands everywhere: paper bought from the stationers with the lines already ruled, but with notes and words filled in afterwards by hand. In this case certainly by a woman’s hand…Yes, most certainly a woman’s hand. The notes were drawn very neat and black and clear and the words were written in a pretty, flowing hand which put a great many twists and turns upon the letters – particularly upon the Ss and the Ws.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She put it down and crossed to the hearth, where her eye was caught by a mark upon the back of a chair. She touched it and found it to be sticky. She put her fingers to her nose and smelt pomade and powder.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Well,’ she said, ‘I would guess one thing about "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mr")]), _vm._v(" Lansdale. I would guess that he puts powder in his hair.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Indeed he does not!’ cried Flora, shocked at the suggestion. ‘Such a nasty, old-fashioned habit! My dear cousin, no gentleman under forty puts powder in his hair now!’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Well then, if you are quite sure, I think we may say that, on the evening of his aunt’s death, Mr Lansdale was visited by an ageing and unfashionable man…Or rather,’ she said, looking across at the chair on the opposite side of the hearth, and seeing a similar stain, ‘by "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("two")]), _vm._v(" ageing and unfashionable men – one of whom was considerably taller than the other.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Dido, now I am sure that you are making things up! How can you possibly know how tall the gentlemen were?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘By the places at which their heads rested upon the chairs. Look. Do you not see that one of the powder stains is much higher than the other?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Oh yes! Why it is true, you "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("are")]), _vm._v(" clever!’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Thank you.’ Dido turned aside knowing that she ought not to take so very much pleasure in the compliment.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As she turned, her eye fell upon the mantel shelf. There was a white and gold china shepherdess, thinly coated in dust, and a very fine pair of branching silver candlesticks – and, propped behind one of the candlesticks, there was a little bit of pasteboard. With a quick glance at the door to be sure they were not overlooked, she picked it up and read what was written on it…")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She stared. Read it again. And then again a third time as if she could not quite believe what she had seen.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Flora,’ she said. ‘Mrs Midgely claims that she is unacquainted with the Lansdales – is that not so?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Yes.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘She says she does not know them at all?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Yes.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Then she is lying.’ She held out the piece of pasteboard. ‘Look, here is her calling card.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Flora’s little mouth dropped open in surprise. But before she could speak, there was a sound of heavy footsteps behind them.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I beg your pardon,’ said a very deep voice. The two women turned rather guiltily and saw, standing in the doorway, precisely the kind of manservant Dido had expected to find in this house: a very tall man – not many inches short of six feet in height – with a high-domed, bald head, an air of extreme dignity and a voice so low that it seemed to echo somewhere deep inside her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I am sorry,’ he said, ‘there has been a mistake. Young Sarah should not have brought you into this room.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Oh!’ cried Dido cheerfully. ‘Do not worry about us. We are quite comfortable here.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I am very glad to hear it, miss.’ The man regarded her with solemn disapproval. ‘But it is not Mr Lansdale’s wish that this room should be used. If you will just step across into the breakfast room…’ he said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And there was nothing for it but to put aside all thoughts and suspicions of Mrs Midgely for the moment and follow the manservant across the entrance hall into a smaller, sunnier apartment where they were soon joined by Mr Lansdale – and Miss Neville, the lady who had been Mrs Lansdale’s companion.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Henry Lansdale, she discovered, was a very handsome young man indeed. And as charming as Flora had made him out to be. He had lively blue eyes, a fine bearing, and a pleasant, unreserved manner. During the first ten minutes of the visit he behaved exactly as he ought upon receiving a visit of condolence. He ran through an account of his aunt’s death; explaining that she had retired to bed early on her last evening. She had been tired, he said, but they had had no reason to think she was at all in danger – until the housemaid discovered her dead in her bed next morning.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He expressed all the proper sentiments as he told this melancholy tale and spoke with very becoming simplicity – and great feeling. But Dido noted that he was not easy; he paced from the hearth to the window and was anxious and restless to a degree for which grief alone could not account.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As he talked, Miss Neville sewed and smiled.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Flora had explained to Dido that Clara Neville was a cousin of the Lansdales who had been living with her mother in Richmond in ‘very reduced circumstances’ before her grand relations came to Knaresborough House and she was invited to join them as a companion. She was a tall, bony woman of perhaps five or six and forty who could not, even in her youth, have been thought pretty – having rather more forehead and less chin than is usually considered desirable.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The smile which occupied her mouth was at odds with the deep lines of discontent and ill-humour on her brow. And, since her mouth was small and her brow wide, the discontent and ill-humour rather got the better of it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her speeches too were a mixture of perfunctory pleasantry and irrepressible discontent. She lamented the death of her cousin loudly, but Dido could not help but suppose that the loss of her own comfortable position was the saddest part of the business, from her, ‘I suppose I shall have to return to mother soon,’ following on almost immediately.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("After a while there was a pause in the conversation and Dido took the opportunity to politely regret the death of the dog – watching Mr Lansdale closely for any sign of consciousness or guilt, as she spoke.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But he only seemed as puzzled as she was herself. ‘That,’ he said turning from the window at which he was standing, ‘is a very strange business indeed. I cannot account for it at all.’ He began to pace about the room once more.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Oh dear!’ cried Flora. ‘I am very sorry! We have raised a subject which distresses you.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘No,’ he said in a softened tone, ‘my dear Mrs Beaumont, please do not be uneasy on that score.’ He sat down beside her. ‘The subject does not distress me,’ he said very gently. ‘It merely puzzles me. I cannot get it out of my head. You see, I know the creature was alive at seven on the evening that my aunt died.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Are you sure of that?’ asked Dido, rather more abruptly than she intended.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Oh yes,’ he said, ‘because I took it down to the kitchen at that time and fed it as I always did. Then I let it out to run about in the garden. It was still in the garden when I left at about half after seven to keep my evening engagement in town.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘You were from home that evening?’ asked Dido keenly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Yes,’ he said looking at her in some surprise.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She blushed. ‘I am sorry. I only meant to say that I suppose you were not able to search for the dog.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘No, I was not. But Miss Neville was here all evening and she says that the butler, Fraser, searched the lawns and called for it. Did he not, Miss Neville?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Oh!’ Miss Neville dropped her work and put her finger to her mouth. ‘I beg your pardon?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I was telling Mrs Beaumont and Miss Kent about the little dog. He was searched for during the evening, was he not?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Oh yes. Yes. Several times.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I see,’ said Dido, with her eyes fixed upon a little spot of fresh blood on the white linen lying in Miss Neville’s lap.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘And I suppose,’ she said, carefully, ‘I suppose you have asked everyone who visited that evening whether they saw the dog?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘There were no visitors that day,’ said Mr Lansdale unhesitatingly. ‘Nor had there been for some days past.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Were there not?’ said Dido with some surprise, remembering the signs of company which they had found in the drawing room.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Oh no,’ said Mr Lansdale, ‘we kept hardly any company.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Dido could not let the opportunity pass her by. ‘Did you not?’ she said, her mind upon Mrs Midgely’s calling card. ‘Your aunt was not upon visiting terms with any of her neighbours?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Oh no. They were not such people…’ He stopped himself and smiled. ‘My aunt, you see, was very particular about the company she kept. It is an invalid’s privilege, is it not?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘And of course,’ added Miss Neville in her whining voice, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("‘we")]), _vm._v(" were not allowed visitors on account of her nerves…Though I am sure,’ she added hastily, bending over her work once more, ‘for my own part I did not mind it one bit. It is much pleasanter to be private, is it not?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There was another short silence which was broken by Mr Lansdale’s sighing. ‘I am grateful,’ he said feelingly, ‘that my poor dear aunt never knew what had happened to the pug. She was extremely fond of the animal.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Oh dear yes! I am sure you all were,’ cried Flora politely.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He made a strange noise and covered his face with his hand. It almost seemed that he might be smothering a laugh.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("At the same time Miss Neville’s grating voice burst out with: ‘Yes, to be sure it is a very great pity. My poor cousin would have been quite heart-broke…Though it was not a nice little dog – barking away every time there was a knock on the house door. And it bit me once. I only picked up and returned a length of sewing cotton which Mrs Lansdale had dropped, and it bit me! And I am sure the servants disliked it too. I doubt there is one of them who has not been bitten by it.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Do you think perhaps one of them…?’ began Dido.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘No,’ said Mr Lansdale quickly. ‘Its death would have upset my aunt to such a degree…put her into such a passion. She would…’ He recollected himself again and stopped. ‘I am sure you understand, Miss Kent, that the state of the mistress’s temper must be of the first importance to her servants.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Yes, of course,’ said Dido, noticing once more his determination to always speak of his aunt with respect – and the effort which it sometimes cost him. She did not doubt that the lady had been just as difficult to defer to when she was alive.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mr Lansdale drummed his fingers on the side of his chair for a moment. Miss Neville continued to sew and smile. But there was something uncomfortable about her smile which Dido could not understand.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Nor could she quite form an opinion of Mr Lansdale. He "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("seemed")]), _vm._v(" all handsome appearance and proper feeling; but how deep this manly beauty went – whether it was a matter of person and manner only, or whether it was rooted in his character, she could not yet tell.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He was certainly unreserved. He had, while talking about his aunt’s death, already alluded to the unkind gossip concerning him and now, after sitting thoughtfully for a few moments, he gave a wry smile. It seemed his youth and high spirits could not long be held in check even by death and danger. ‘What I cannot quite determine,’ he said, ‘is whether the death of the dog will exonerate me in the eyes of my neighbours, or whether it will confirm me a murderer.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘A murderer!’ cried Flora. ‘How perfectly horrid! I beg you will not say such things.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But Dido held his gaze and said quietly. ‘Yes, Mr Lansdale, I am finding that point difficult to settle myself.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The remark served to fix his attention upon her. Until that moment she had been only the lovely Mrs Beaumont’s poor cousin; but now, all at once, she had an existence of her own.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Miss Kent!’ he cried, smiling, ‘I do believe that you suspect me!’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Flora hastened to assure him that her cousin had no such doubts, that it was just too horrid for words to even suggest it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But Dido waited until she had finished speaking and then, finding that the young man was still regarding her with slightly raised brows and shining eyes full of questions, she said, very seriously, ‘No, Mr Lansdale. Upon consideration I do not think that I suspect you. From what you have told me, the evidence seems to be in your favour.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He shook his head and became suddenly solemn. ‘I am very glad to find that I have your good opinion, Miss Kent – and,’ turning with a softened voice, ‘yours too Mrs Beaumont.’ He sighed deeply. ‘And you are quite right. Those who can suspect me of lacking affection for my aunt quite mistake the matter.’ He paused again. ‘If I am guilty of anything,’ he said with great feeling, ‘it is certainly not a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("lack")]), _vm._v(" of affection.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was said very quietly, very properly and Dido did not doubt he meant to convey regard and respect for his dead relation. But, all the same, she could not quite like the way in which his gaze fell upon Flora as he spoke.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It started a new – and entirely unwelcome – suspicion in her head.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3fc2b9b5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781429967839_ch03.vue
// module id = 75
// module chunks = 0